import React from 'react'

interface StatusCardProps {
  title: string
  value: number | string
  icon?: React.ReactNode
  bgColor?: string
  textColor?: string
  className?: string
}

export function StatusCard({
  title,
  value,
  icon,
  bgColor = 'bg-light',
  textColor = 'text-dark',
  className = '',
}: StatusCardProps) {
  return (
    <div
      className={`card border-0 shadow-sm h-100 ${bgColor} ${className}`}
      style={{ minHeight: '140px' }}
    >
      <div className="card-body d-flex flex-column justify-content-between">
        <div className="d-flex justify-content-between align-items-start">
          <div className="flex-grow-1">
            <p className="card-text text-muted fw-500 mb-2 fs-sm">{title}</p>
            <h3 className={`card-title mb-0 ${textColor}`}>{value}</h3>
          </div>
          {icon && <div className="fs-1 text-primary opacity-75">{icon}</div>}
        </div>
      </div>
    </div>
  )
}
